import { Action, Dispatch } from "redux";
import axios from "../../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../../config/constants";
import * as action_types from "./constants";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getUnitsById = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getUnitsById/${id}`);
      dispatch({
        type: action_types.UNIT_LISTING,
        payload: { data: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.UNIT_LISTING,
        payload: { loading: false },
      });
    }
  };
};

export const removeUnitListingData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.UNIT_LISTING,
      payload: { data: {}, loading: true },
    });
  };
};
